import api from "./api";

class AnagraficheManager {

    anagrafiche(config?: any) {
        return api.get(`/anagrafiche`, config)
    }

    anagrafica(aziende_id: number | string | undefined, config?: any) {
        return api.get(`/anagrafiche/${aziende_id}`, config)
    }

    retrieve = this.anagrafica
    list = this.anagrafiche
    paginatedList = this.anagrafiche
}

const anagraficheManager = new AnagraficheManager()

export default anagraficheManager
